import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { listItems } from "../api/items.js";
import type { ItemFiltersQuery, ListItemsResponse } from "../api/types.js";
import { useApiClient } from "../api/ApiClientContext.js";

export function useItems(filters: ItemFiltersQuery): UseQueryResult<ListItemsResponse> {
  const client = useApiClient();
  return useQuery({
    queryKey: ["items", filters],
    queryFn: () => listItems(client, filters),
    placeholderData: (previous) => previous,
  });
}
